import slugify from 'slugify';
import { getDisplayNameFromMemberFamily } from '~/lib/family';
export const useFamilyMember = (mb: Ref<FamilyMember> | FamilyMember) => {
  const context = useContextStore();

  const member = ref<FamilyMember>(toValue(mb));

  const profile = useProfileStore();

  const isCurrentUser = computed(
    () => member.value.memberId === context.memberId
  );

  const displayInfos = computed<ProfilingInfo[]>(() => {
    if (member.value.profilingInfos && member.value.profilingInfos.length) {
      return member.value.profilingInfos;
    } else if (
      member.value.levelOfEducationLongName ||
      member.value.levelOfEducationName
    ) {
      return [
        {
          label: 'Niveau',
          value:
            member.value.levelOfEducationLongName ||
            member.value.levelOfEducationName,
        },
      ];
    }
    return null;
  });

  const email = computed(() => {
    if (member.value && member.value.email && member.value.displayEmail) {
      return member.value.email;
    }

    return null;
  });

  const familyInviteUrl = computed(() => {
    return member.value.familyInviteUrl ?? null;
  });

  const details = computed(() => {
    if (status.value === 'parent') return 'Parent';
    return (
      (member.value.levelOfEducationLongName ||
        member.value.levelOfEducationName) ??
      ''
    );
  });

  const displayInviteButton = computed(
    () => member.value.displayInviteButton ?? false
  );

  const shareResultsWithFamily = computed(() => {
    globalThis.$logger.info(
      'useFamilyMember ::: shareResultsWithFamily',
      member.value.shareResultsWithFamily
    );
    return member.value.shareResultsWithFamily ?? false;
  });

  const displayName = computed(() => {
    return getDisplayNameFromMemberFamily(member.value);
  });

  const gamingXp = computed(() => {
    return member.value.gamingXp;
  });

  const memberId = computed(() => {
    return member.value.memberId;
  });

  const coachingInfos = computed<CoachingInfos>(
    () => member.value.coaching ?? null
  );

  const userType = computed<'placeholder' | 'child' | 'parent'>(() => {
    if (member.value.isPlaceholder) return 'placeholder';
    if (member.value.levelOfEducationName) return 'child';
    return 'parent';
  });

  const status = computed(() => member.value.status);

  const isPlaceholder = computed(() => member.value.isPlaceholder);

  const slug = computed(() => {
    if (member.value.memberId === context.memberId) return `moi`;
    const id = member.value.memberId.slice(-5);
    if (!member.value.isPlaceholder) {
      return slugify(`${displayName.value.toLowerCase()}-${id}`);
    }
    return slugify(`${id}`);
  });

  const memberUrl = computed(() => '/famille/' + slug.value);

  const canAccessFamilyStats = computed(() => {
    return profile.isParent;
  });

  const showStats = computed(() => {
    if (!canAccessFamilyStats.value) return false;

    return (
      shareResultsWithFamily.value ||
      userType.value === 'placeholder' ||
      memberId.value === context.memberId
    );
  });

  const needRefreshProfiling = computed(() => {
    return member.value.refreshProfiling != null;
  });

  watchEffect(() => {
    member.value = toValue(mb);
  });

  return {
    userType,
    displayInfos,
    displayInviteButton,
    displayName,
    coachingInfos,
    shareResultsWithFamily,
    isCurrentUser,
    slug,
    memberUrl,
    details,
    gamingXp,
    memberId,
    email,
    status,
    familyInviteUrl,
    isPlaceholder,
    showStats,
    needRefreshProfiling,
  };
};
